import * as $runtime from "../runtime.js";
import * as Control$dMonad$dWriter$dTrans from "../Control.Monad.Writer.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dExtra from "../Data.Map.Extra/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dParameter from "../Restaumatic.Menu.V2.Parameter/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const tell = /* #__PURE__ */ (() => Control$dMonad$dWriter$dTrans.monadTellWriterT(Data$dMonoid.monoidArray)(Data$dEither.monadEither).tell)();
const showEither = dictShow1 => (
  {
    show: v => {
      if (v.tag === "Left") { return "(Left " + Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showFatalError.show(v._1) + ")"; }
      if (v.tag === "Right") { return "(Right " + dictShow1.show(v._1) + ")"; }
      $runtime.fail();
    }
  }
);
const showArray = /* #__PURE__ */ (() => ({show: Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showSoftError.show)}))();
const all = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupConj1 = {append: v => v1 => v && v1};
  return {mempty: true, Semigroup0: () => semigroupConj1};
})()))();
const mapKeys = /* #__PURE__ */ Data$dMap$dExtra.mapKeys(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId);
const identity = x => x;
const append = /* #__PURE__ */ Data$dMap$dOrdered.union(Data$dOrd.ordString);
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return y; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return x; }
  $runtime.fail();
};
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const fromOccurArray = /* #__PURE__ */ Data$dMultiSet.fromOccurArray(Data$dOrd.ordString);
const restoreOrderingOccur = /* #__PURE__ */ Data$dMultiSet.restoreOrderingOccur(Data$dOrd.ordString);
const difference = /* #__PURE__ */ Data$dMultiSet.difference(Data$dOrd.ordString);
const fromArray = /* #__PURE__ */ Data$dMultiSet.fromArray(Data$dOrd.ordString);
const sum = /* #__PURE__ */ (() => Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0))();
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const fold1 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMap$dInternal.monoidMap(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId))(Data$dFoldable.identity))();
const fold2 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dSet.monoidSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId))(Data$dFoldable.identity))();
const fromFoldable2 = /* #__PURE__ */ Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dOrd.ordString)(a)()(m))(Data$dMap$dInternal.Leaf);
const fold3 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidArray)(Data$dFoldable.identity))();
const sum1 = /* #__PURE__ */ (() => Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0))();
const intercalate = sep => xs => Data$dFoldable.foldlArray(v => v1 => {
  if (v.init) { return {init: false, acc: v1}; }
  return {init: false, acc: v.acc + sep + v1};
})({init: true, acc: ""})(xs).acc;
const CartToOrder = x => x;
const withName = k => n => ({id: k, name: n});
const toSimpleParametricEvaluationError = v => {
  if (v.tag === "MissingParameters") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SimpleParametricEvaluationError("MissingParameters", v._1); }
  if (v.tag === "MissingValue") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.MissingValue; }
  $runtime.fail();
};
const toAvailabilityScheduleInternalParameterValues = /* #__PURE__ */ (() => {
  const $0 = Data$dMap$dInternal.functorMap.map(Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.ScheduleChoice);
  const $1 = Data$dMap$dExtra.mapKeys(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.Schedule);
  return x => $0($1(x));
})();
const softError = error => tell([error]);
const newtypeCartToOrder = {Coercible0: () => {}};
const runCartToOrder = x => x;
const showCartToOrder = dictShow => ({show: showEither({show: v => "(Tuple " + dictShow.show(v._1) + " " + showArray.show(v._2) + ")"}).show});
const monadCartToOrder = /* #__PURE__ */ Control$dMonad$dWriter$dTrans.monadWriterT(Data$dMonoid.monoidArray)(Data$dEither.monadEither);
const hasSingleValue = dictEq => narr => {
  const $0 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, narr, 0);
  const h = (() => {
    if ($0.tag === "Just") { return $0._1; }
    $runtime.fail();
  })();
  if (
    all(tv => dictEq.eq(tv)(h))((() => {
      const $1 = Data$dArray.unconsImpl(v => Data$dMaybe.Nothing, v => xs => Data$dMaybe.$Maybe("Just", xs), narr);
      if ($1.tag === "Just") { return $1._1; }
      $runtime.fail();
    })())
  ) {
    return Data$dMaybe.$Maybe("Just", h);
  }
  return Data$dMaybe.Nothing;
};
const functorCartToOrder = /* #__PURE__ */ Control$dMonad$dWriter$dTrans.functorWriterT(Data$dEither.functorEither);
const fromInternalParameterValues = /* #__PURE__ */ (() => {
  const $0 = mapKeys(Restaumatic$dMenu$dV2$dTypes$dParameterId.InternalParameter);
  const $1 = Data$dMap$dInternal.functorMap.map(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.InternalParameterChoice);
  return x => $0($1(x));
})();
const fromCustomParameterValues = /* #__PURE__ */ (() => {
  const $0 = mapKeys(Restaumatic$dMenu$dV2$dTypes$dParameterId.CustomParameter);
  const $1 = Data$dMap$dInternal.functorMap.map(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.CustomParameterChoice);
  return x => $0($1(x));
})();
const fatalError = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dWriter$dTrans.monadTransWriterT(Data$dMonoid.monoidArray).lift(Data$dEither.monadEither);
  return x => $0(Data$dEither.$Either("Left", x));
})();
const defaultModifierSettings = {
  editable: Restaumatic$dMenu$dV2$dParametric.always,
  inputRequired: Restaumatic$dMenu$dV2$dParametric.noValue,
  freeItems: 0,
  defaultItems: Data$dMaybe.Nothing,
  displayDefaultItems: false
};
const calculateAvailabilityScheduleValues = catalogue => localTime => Data$dMap$dInternal.functorMap.map(x => Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(x.availability)(localTime))(Restaumatic$dCalendar$dTypes$dAvailability.Available))(catalogue.availabilitySchedules);
const bindCartToOrder = /* #__PURE__ */ Control$dMonad$dWriter$dTrans.bindWriterT(Data$dSemigroup.semigroupArray)(Data$dEither.bindEither);
const applyCartToOrder = /* #__PURE__ */ Control$dMonad$dWriter$dTrans.applyWriterT(Data$dSemigroup.semigroupArray)(Data$dEither.applyEither);
const applicativeCartToOrder = /* #__PURE__ */ Control$dMonad$dWriter$dTrans.applicativeWriterT(Data$dMonoid.monoidArray)(Data$dEither.applicativeEither);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(applicativeCartToOrder);
const for_1 = /* #__PURE__ */ for_(Data$dFoldable.foldableMaybe);
const for_2 = /* #__PURE__ */ for_(Data$dFoldable.foldableArray);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(applicativeCartToOrder))();
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(applicativeCartToOrder)(Data$dFoldable.foldableArray);
const traverse1 = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(applicativeCartToOrder))();
const for1 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(applicativeCartToOrder);
  return x => f => traverse2(f)(x);
})();
const for2 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(applicativeCartToOrder);
  return x => f => traverse2(f)(x);
})();
const checkGeneralAvailability = err => id => availability => {
  const $0 = availability.tag === "Available";
  const $1 = tell([err(id)]);
  if (!$0) { return $1; }
  if ($0) { return applicativeCartToOrder.pure(); }
  $runtime.fail();
};
const evaluateParametricM = p => v => {
  const v1 = Restaumatic$dMenu$dV2$dParametric.evaluateParametric(p)(v);
  if (v1.tag === "Left") {
    return fatalError(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
      "ParametricError",
      (() => {
        if (v1._1.tag === "MissingParameters") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SimpleParametricEvaluationError("MissingParameters", v1._1._1); }
        if (v1._1.tag === "MissingValue") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.MissingValue; }
        $runtime.fail();
      })()
    ));
  }
  if (v1.tag === "Right") { return applicativeCartToOrder.pure(v1._1); }
  $runtime.fail();
};
const internalParameterToParameterAttributes = parameterValues => parameterId => applicativeCartToOrder.pure((() => {
  const $0 = Data$dMap$dInternal.lookup(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)(parameterId)(parameterValues);
  if ($0.tag === "Just") {
    return Data$dMaybe.$Maybe(
      "Just",
      {
        parameter: {
          id: Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("InternalParameter", parameterId),
          name: Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.showInternalParameterId.show(parameterId)
        },
        choice: {
          id: Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("InternalParameterChoice", $0._1),
          name: Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.showInternalParameterChoiceId.show($0._1)
        }
      }
    );
  }
  if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
})());
const orFatal = v => v1 => {
  if (v.tag === "Just") { return applicativeCartToOrder.pure(v._1); }
  if (v.tag === "Nothing") { return fatalError(v1); }
  $runtime.fail();
};
const cartModifierToItemAttributes = locale => getModifierSettings => parameterValues => modifierValues => scaleValue => v => {
  const $0 = v._1;
  const removedItemCredit = (() => {
    if (v._2.exchangePolicy.tag === "NotIncluded") { return v$1 => 0; }
    if (v._2.exchangePolicy.tag === "UnlimitedExchange") { return identity; }
    if (v._2.exchangePolicy.tag === "ExchangeWithClamp") { return identity; }
    if (v._2.exchangePolicy.tag === "AdditionOnly") { return v$1 => 0; }
    $runtime.fail();
  })();
  const processItem = sectionItems => freeItems => calcValue => v1 => {
    const $1 = v1._1;
    const $2 = v1._2;
    return bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)($1)(sectionItems))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
      "InvalidModifierValue",
      $0,
      $1
    )))(v2 => bindCartToOrder.bind(evaluateParametricM(v2.price)(parameterValues))(unitPrice => applicativeCartToOrder.pure({
      modifierItem: {id: $1, name: Restaumatic$dI18n$dTypes.getLocalization(locale)(v2.name)},
      quantity: $2,
      value: scaleValue(calcValue(($2 - Data$dMultiSet.occur(Data$dOrd.ordString)($1)(freeItems) | 0) * unitPrice | 0))
    })));
  };
  const $1 = getModifierSettings($0);
  const modifierSettings = (() => {
    if ($1.tag === "Nothing") { return defaultModifierSettings; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  })();
  const clampExchange = (() => {
    if (v._2.exchangePolicy.tag === "NotIncluded") { return identity; }
    if (v._2.exchangePolicy.tag === "UnlimitedExchange") { return identity; }
    if (v._2.exchangePolicy.tag === "ExchangeWithClamp") { return max(0); }
    if (v._2.exchangePolicy.tag === "AdditionOnly") { return identity; }
    $runtime.fail();
  })();
  const allSectionItems = Data$dFoldable.foldlArray(append)(Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []))(Data$dFunctor.arrayMap(section => section.items)(v._2.sections))._1;
  const $2 = Data$dArray.mapMaybe(v1 => {
    if (v1._2.defaultSelection > 0) { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(v1._1, v1._2.defaultSelection)); }
    return Data$dMaybe.Nothing;
  })(toUnfoldable(allSectionItems));
  const $3 = Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple);
  const $4 = modifierSettings.defaultItems.tag === "Just" ? Data$dMaybe.$Maybe("Just", $3(modifierSettings.defaultItems._1)) : Data$dMaybe.Nothing;
  const defaultItems = (() => {
    if ($4.tag === "Nothing") { return $2; }
    if ($4.tag === "Just") { return $4._1; }
    $runtime.fail();
  })();
  if (Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")(v._2))(parameterValues)) {
    return bindCartToOrder.bind(Restaumatic$dMenu$dV2$dParametric.eq1(Restaumatic$dMenu$dV2$dParametric.evaluateParametric(v._2.userEditableWhen)(parameterValues))(Data$dEither.$Either(
      "Right",
      true
    )) && Restaumatic$dMenu$dV2$dParametric.eq1(Restaumatic$dMenu$dV2$dParametric.evaluateParametric(modifierSettings.editable)(parameterValues))(Data$dEither.$Either(
      "Right",
      true
    ))
      ? orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)($0)(modifierValues))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("ModifierNotSet", $0))
      : applicativeCartToOrder.pure(fromOccurArray(defaultItems)))(selectedItems => bindCartToOrder.bind(bindCartToOrder.bind((() => {
      const $5 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("InvalidModifierItemCount", $0)]);
      if (
        (() => {
          const go = (z$p, m$p) => {
            if (m$p.tag === "Leaf") { return z$p; }
            if (m$p.tag === "Node") { return go(go(z$p, m$p._5) + m$p._4 | 0, m$p._6); }
            $runtime.fail();
          };
          return go(0, selectedItems) < v._2.minItems;
        })()
      ) {
        return $5;
      }
      return applicativeCartToOrder.pure();
    })())(() => bindCartToOrder.bind(for_1(v._2.maxItems)(maxItems => {
      const $5 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("InvalidModifierItemCount", $0)]);
      if (
        (() => {
          const go = (z$p, m$p) => {
            if (m$p.tag === "Leaf") { return z$p; }
            if (m$p.tag === "Node") { return go(go(z$p, m$p._5) + m$p._4 | 0, m$p._6); }
            $runtime.fail();
          };
          return go(0, selectedItems) > maxItems;
        })()
      ) {
        return $5;
      }
      return applicativeCartToOrder.pure();
    }))(() => for_1(v._2.maxDuplicatesPerItem)(maxDuplicatesPerItem => for_2(Data$dMultiSet.toOccurArray(selectedItems))(v1 => {
      const $5 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("InvalidModifierItemDuplicateCount", $0, v1._1)]);
      if (v1._2 > maxDuplicatesPerItem) { return $5; }
      return applicativeCartToOrder.pure();
    })))))(() => {
      const defaultIncludedItemsSet = fromOccurArray(v._2.exchangePolicy.tag === "NotIncluded" ? [] : defaultItems);
      const orderedIncludedItems = restoreOrderingOccur(Data$dFunctor.arrayMap(Data$dTuple.fst)(defaultItems))(Data$dMap$dInternal.unsafeIntersectionWith(
        Data$dOrd.ordString.compare,
        Data$dMultiSet.min,
        defaultIncludedItemsSet,
        selectedItems
      ));
      const removedItems = difference(defaultIncludedItemsSet)(selectedItems);
      const orderedRemovedItems = restoreOrderingOccur(Data$dFunctor.arrayMap(Data$dTuple.fst)(defaultItems))(removedItems);
      const addedItems = difference(selectedItems)(defaultIncludedItemsSet);
      const orderedAddedItems = restoreOrderingOccur(Data$dFunctor.arrayMap(Data$dTuple.fst)(defaultItems))(addedItems);
      return bindCartToOrder.bind(traverse(itemId => bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemId)(allSectionItems))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
        "InvalidModifierValue",
        $0,
        itemId
      )))(v1 => bindCartToOrder.bind(evaluateParametricM(v1.price)(parameterValues))(unitPrice => applicativeCartToOrder.pure(Data$dTuple.$Tuple(itemId, unitPrice)))))(Data$dMultiSet.elems(addedItems)))(addedItemsWithPrices => {
        const excludeFreeAddedItems = fromArray((() => {
          const $5 = Data$dFunctor.arrayMap(Data$dTuple.fst)(Data$dArray.sortWith(Data$dOrd.ordInt)(x => -x._2)(addedItemsWithPrices));
          if (modifierSettings.freeItems < 1) { return []; }
          return Data$dArray.sliceImpl(0, modifierSettings.freeItems, $5);
        })());
        return bindCartToOrder.bind(traverse(processItem(allSectionItems)(Data$dMap$dInternal.Leaf)(v$1 => 0))(orderedIncludedItems))(includedItemAttributes => bindCartToOrder.bind(traverse(processItem(allSectionItems)(excludeFreeAddedItems)(identity))(orderedAddedItems))(addedItemAttributes => bindCartToOrder.bind(traverse(processItem(allSectionItems)(Data$dMap$dInternal.Leaf)(removedItemCredit))(orderedRemovedItems))(removedItemAttributes => bindCartToOrder.bind(traverse_(itemId => bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemId)(allSectionItems))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
          "InvalidModifierValue",
          $0,
          itemId
        )))(v1 => {
          const $5 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("IrremovableModifierItem", $0, itemId)]);
          if (v1.irremovable) { return $5; }
          return applicativeCartToOrder.pure();
        }))(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, Data$dMap.keys(removedItems))))(() => bindCartToOrder.bind(traverse_(itemId => bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemId)(allSectionItems))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
          "InvalidModifierValue",
          $0,
          itemId
        )))(v1 => bindCartToOrder.bind((() => {
          const $5 = v1.availability.tag === "Available";
          const $6 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("ModifierItemNotAvailable", $0, itemId)]);
          if (!$5) { return $6; }
          if ($5) { return applicativeCartToOrder.pure(); }
          $runtime.fail();
        })())(() => {
          const $5 = Restaumatic$dMenu$dV2$dParametric.eq1(Restaumatic$dMenu$dV2$dParametric.evaluateParametric(v1.availableWhen)(parameterValues))(Data$dEither.$Either(
            "Right",
            true
          ));
          const $6 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("ModifierItemNotAvailable", $0, itemId)]);
          if (!$5) { return $6; }
          if ($5) { return applicativeCartToOrder.pure(); }
          $runtime.fail();
        })))(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, Data$dMap.keys(addedItems))))(() => applicativeCartToOrder.pure(Data$dMaybe.$Maybe(
          "Just",
          {
            modifier: {id: $0, name: Restaumatic$dI18n$dTypes.getLocalization(locale)(v._2.name)},
            includedItems: includedItemAttributes,
            addedItems: addedItemAttributes,
            removedItems: removedItemAttributes,
            value: clampExchange(sum(Data$dFunctor.arrayMap(v1 => v1.value)(addedItemAttributes)) - sum(Data$dFunctor.arrayMap(v1 => v1.value)(removedItemAttributes)) | 0),
            vatRate: v._2.modifierVatRate
          }
        )))))));
      });
    }));
  }
  return applicativeCartToOrder.pure(Data$dMaybe.Nothing);
};
const checkAvailabilitySchedule = err => schedules => id => availabilitySchedule => for_1(availabilitySchedule)(scheduleId => bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(scheduleId)(schedules))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
  "AvailabilityScheduleNotFound",
  scheduleId
)))(isAvailable => {
  const $0 = tell([err(id)]);
  if (!isAvailable) { return $0; }
  if (isAvailable) { return applicativeCartToOrder.pure(); }
  $runtime.fail();
}));
const customParameterToParameterAttributes = locale => parameterValues => v => {
  const $0 = v._2;
  const $1 = v._1;
  return bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId(
    "CustomParameter",
    $1
  ))(parameterValues))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("CustomParameterNotSet", $1)))(v1 => bindCartToOrder.bind(orFatal(v1.tag === "CustomParameterChoice"
    ? Data$dMaybe.$Maybe("Just", v1._1)
    : Data$dMaybe.Nothing)(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("InvalidParameterValue", $1)))(v2 => bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v2)($0.choices._1))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
    "InvalidParameterValue",
    $1
  )))(choice => bindCartToOrder.bind(checkGeneralAvailability(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ParameterChoiceNotAvailable)($1)(choice.availability))(() => bindCartToOrder.bind((() => {
    const $2 = Restaumatic$dMenu$dV2$dParametric.eq1(Restaumatic$dMenu$dV2$dParametric.evaluateParametric(choice.availableWhen)(parameterValues))(Data$dEither.$Either(
      "Right",
      true
    ));
    const $3 = tell([Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$SoftError("ParameterChoiceNotAvailable", $1)]);
    if (!$2) { return $3; }
    if ($2) { return applicativeCartToOrder.pure(); }
    $runtime.fail();
  })())(() => applicativeCartToOrder.pure({
    parameter: {id: Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("CustomParameter", $1), name: Restaumatic$dI18n$dTypes.getLocalization(locale)($0.name)},
    choice: {
      id: Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("CustomParameterChoice", v2),
      name: Restaumatic$dI18n$dTypes.getLocalization(locale)(choice.name)
    }
  }))))));
};
const cartProductToOrderItems = catalogue => locale => availabilityScheduleValues => cartProductKey => internalParameters => priceOverrides => {
  const numberOfParts = length(cartProductKey.parts);
  const loadParameter = id => orFatal((() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(catalogue.customParameters);
    if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(id, $0._1)); }
    return Data$dMaybe.Nothing;
  })())(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("ParameterNotFound", id));
  const loadModifier = id => orFatal((() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(catalogue.modifiers);
    if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(id, $0._1)); }
    return Data$dMaybe.Nothing;
  })())(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("ModifierNotFound", id));
  const nonDivisibleModifierValues = Data$dMap$dInternal.functorMap.map(Unsafe$dCoerce.unsafeCoerce)(cartProductKey.modifiers);
  const allInternalParameterValues = fold1([
    internalParameters,
    Data$dMap$dInternal.$$$Map(
      "Node",
      1,
      1,
      Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.IsDivided,
      Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("IsDividedChoice", numberOfParts > 1),
      Data$dMap$dInternal.Leaf,
      Data$dMap$dInternal.Leaf
    ),
    toAvailabilityScheduleInternalParameterValues(availabilityScheduleValues)
  ]);
  const allNonDivisibleParameterValues = Data$dMap$dInternal.unsafeUnionWith(
    Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare,
    Data$dFunction.const,
    fromInternalParameterValues(allInternalParameterValues),
    fromCustomParameterValues(cartProductKey.customParameters)
  );
  return bindCartToOrder.bind(traverse1(v => orFatal((() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v._2.productId)(catalogue.products);
    if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", {index: v._1, key: v._2, product: $0._1}); }
    return Data$dMaybe.Nothing;
  })())(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("ProductNotFound", v._2.productId)))(Data$dArray.zipWithImpl(
    Data$dTuple.Tuple,
    Data$dArray.rangeImpl(0, numberOfParts),
    cartProductKey.parts
  )))(partKeysWithProducts => bindCartToOrder.bind(orFatal(hasSingleValue(Data$dEq.eqString)(Data$dFunctor.arrayMap(x => x.product.category)(partKeysWithProducts)))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.DistinctCategories))(categoryId => bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(categoryId)(catalogue.categories))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.CategoryNotFound))(category => bindCartToOrder.bind((() => {
    if (
      (() => {
        const $0 = Restaumatic$dMenu$dV2$dParametric.evaluateParametric(category.divisibleV2)(allNonDivisibleParameterValues);
        if ($0.tag === "Left") { return false; }
        if ($0.tag === "Right") { return $0._1; }
        $runtime.fail();
      })()
    ) {
      const $0 = fatalError(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.TooManyParts);
      if (numberOfParts > 2) { return $0; }
      return applicativeCartToOrder.pure();
    }
    const $0 = fatalError(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.TooManyParts);
    if (numberOfParts > 1) { return $0; }
    return applicativeCartToOrder.pure();
  })())(() => {
    const catalogueMemo = {catalogue, parametersMemo: {value: Data$dMap$dInternal.Leaf}};
    const allParameterIds = fold2(Data$dFunctor.arrayMap(x => Restaumatic$dMenu$dV2$dParameter.productParameters(catalogueMemo)(Data$dRecord.unsafeGet("productId")(x.key)))(Data$dArray.fromFoldableImpl(
      Data$dFoldable.foldrArray,
      partKeysWithProducts
    )));
    const allInternalParameterIds = Restaumatic$dMenu$dV2$dParametric.onlyInternalParameters(allParameterIds);
    return bindCartToOrder.bind(traverse(loadParameter)(Data$dArray.fromFoldableImpl(
      Data$dSet.foldableSet.foldr,
      Restaumatic$dMenu$dV2$dParametric.onlyCustomParameters(allParameterIds)
    )))(allCustomParameters => {
      const nonDivisibleCustomParameters = Data$dArray.filterImpl(x => !x._2.divisible, allCustomParameters);
      const nonDivisibleCustomParametersIds = fromFoldable2(Data$dFunctor.arrayMap(Data$dTuple.fst)(nonDivisibleCustomParameters));
      return bindCartToOrder.bind(bindCartToOrder.bind(traverse(customParameterToParameterAttributes(locale)(allNonDivisibleParameterValues))(nonDivisibleCustomParameters))(customParameterResult => bindCartToOrder.bind(functorCartToOrder.map(Data$dArray.catMaybes)(traverse(internalParameterToParameterAttributes(allInternalParameterValues))(Data$dArray.fromFoldableImpl(
        Data$dSet.foldableSet.foldr,
        allInternalParameterIds
      ))))(internalParameterResult => applicativeCartToOrder.pure(Data$dSemigroup.concatArray(customParameterResult)(internalParameterResult)))))(nonDivisibleParametersResult => bindCartToOrder.bind(traverse(loadModifier)(Data$dArray.fromFoldableImpl(
        Data$dSet.foldableSet.foldr,
        fromFoldable2(fold3(Data$dSemigroup.concatArray([category.categoryModifiers])(Data$dFunctor.arrayMap(x => x.product.productModifiers)(Data$dArray.fromFoldableImpl(
          Data$dFoldable.foldrArray,
          partKeysWithProducts
        )))))
      )))(allPartsModifiers => {
        const nonDivisibleModifiers = Data$dArray.filterImpl(x => !x._2.divisible, allPartsModifiers);
        const nonDivisibleModifierIds = fromFoldable2(Data$dFunctor.arrayMap(Data$dTuple.fst)(nonDivisibleModifiers));
        return bindCartToOrder.bind(functorCartToOrder.map(Data$dArray.catMaybes)(traverse(cartModifierToItemAttributes(locale)(v => Data$dMaybe.$Maybe(
          "Just",
          defaultModifierSettings
        ))(allNonDivisibleParameterValues)(nonDivisibleModifierValues)(identity))(nonDivisibleModifiers)))(modifierResult => bindCartToOrder.bind(for1(partKeysWithProducts)(v => {
          const $0 = v.index;
          return bindCartToOrder.bind(evaluateParametricM(Data$dMap$dExtra.findWithDefault(Data$dOrd.ordString)(v.product.price)(v.key.productId)(priceOverrides))(Data$dMap$dInternal.unsafeUnionWith(
            Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare,
            Data$dFunction.const,
            allNonDivisibleParameterValues,
            fromCustomParameterValues(v.key.customParameters)
          )))(fullProductPrice => applicativeCartToOrder.pure(Data$dTuple.$Tuple($0, fullProductPrice)));
        }))(v => {
          const $0 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v, 0);
          const $1 = (() => {
            if ($0.tag === "Just") { return $0._1; }
            $runtime.fail();
          })();
          const $2 = Data$dFoldable.maximumBy(Data$dFoldable.foldableArray)(x => y => Data$dOrd.ordInt.compare(x._2)(y._2))(v);
          const mostExpensivePartIndex = (() => {
            if ($2.tag === "Nothing") { return $1._1; }
            if ($2.tag === "Just") { return $2._1._1; }
            $runtime.fail();
          })();
          return bindCartToOrder.bind(for1(partKeysWithProducts)(v1 => {
            const $3 = v1.index;
            const $4 = v1.key;
            const $5 = v1.product;
            const productId = $4.productId;
            return bindCartToOrder.bind(checkGeneralAvailability(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ProductNotAvailable)(productId)($5.availability))(() => bindCartToOrder.bind(checkAvailabilitySchedule(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ProductNotAvailable)(availabilityScheduleValues)(productId)($5.availabilitySchedule))(() => {
              const divisibleCustomParametersIds = Data$dMap$dInternal.unsafeDifference(
                Data$dOrd.ordString.compare,
                Restaumatic$dMenu$dV2$dParametric.onlyCustomParameters(Restaumatic$dMenu$dV2$dParameter.productParameters(catalogueMemo)(productId)),
                nonDivisibleCustomParametersIds
              );
              const allProductParameterValues = Data$dMap$dInternal.unsafeUnionWith(
                Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare,
                Data$dFunction.const,
                allNonDivisibleParameterValues,
                fromCustomParameterValues($4.customParameters)
              );
              return bindCartToOrder.bind((() => {
                const $6 = Restaumatic$dMenu$dV2$dParametric.eq1(Restaumatic$dMenu$dV2$dParametric.evaluateParametric($5.variants)(allProductParameterValues))(Data$dEither.$Either(
                  "Right",
                  true
                ));
                const $7 = fatalError(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("VariantNotAvailable", productId));
                if (!$6) { return $7; }
                if ($6) { return applicativeCartToOrder.pure(); }
                $runtime.fail();
              })())(() => bindCartToOrder.bind(traverse(loadParameter)(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, divisibleCustomParametersIds)))(divisibleParameters => bindCartToOrder.bind(traverse(customParameterToParameterAttributes(locale)(allProductParameterValues))(divisibleParameters))(productParameterResult => {
                const productModifierValues = Data$dMap$dInternal.functorMap.map(Unsafe$dCoerce.unsafeCoerce)($4.modifiers);
                const $6 = $5.modifierSettings;
                return bindCartToOrder.bind(traverse(loadModifier)(Data$dArray.fromFoldableImpl(
                  Data$dSet.foldableSet.foldr,
                  Data$dMap$dInternal.unsafeDifference(
                    Data$dOrd.ordString.compare,
                    fromFoldable2(Restaumatic$dMenu$dV2$dParameter.allModifiers(catalogueMemo)($5)),
                    nonDivisibleModifierIds
                  )
                )))(divisibleModifiers => bindCartToOrder.bind(traverse(cartModifierToItemAttributes(locale)(a => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(a)($6))(allProductParameterValues)(productModifierValues)(x => Data$dMoney$dRounded.roundCents(Data$dInt.toNumber(x) / 100.0 / Data$dInt.toNumber(numberOfParts) * 100.0)))(divisibleModifiers))(productModifierResult => bindCartToOrder.bind(evaluateParametricM(Data$dMap$dExtra.findWithDefault(Data$dOrd.ordString)($5.price)(productId)(priceOverrides))(allProductParameterValues))(fullProductPrice => applicativeCartToOrder.pure({
                  product: {id: productId, name: Restaumatic$dI18n$dTypes.getLocalization(locale)($5.name)},
                  parameters: productParameterResult,
                  modifiers: Data$dArray.mapMaybe(x => x)(productModifierResult),
                  value: (() => {
                    if (category.divisiblePricePolicy.tag === "Average") {
                      return Data$dMoney$dRounded.roundCents(Data$dInt.toNumber(fullProductPrice) / 100.0 / Data$dInt.toNumber(numberOfParts) * 100.0);
                    }
                    if (category.divisiblePricePolicy.tag === "MostExpensive") {
                      if ($3 === mostExpensivePartIndex) { return fullProductPrice; }
                      return 0;
                    }
                    $runtime.fail();
                  })(),
                  vatRate: category.vatRate
                }))));
              })));
            }));
          }))(partsAttributes => applicativeCartToOrder.pure({
            unitPrice: sum1(Data$dFunctor.arrayMap(part => part.value + sum(Data$dFunctor.arrayMap(v1 => v1.value)(part.modifiers)) | 0)(partsAttributes)) + sum(Data$dFunctor.arrayMap(v1 => v1.value)(modifierResult)) | 0,
            name: intercalate(" / ")(Data$dFunctor.arrayMap(v1 => v1.product.name)(partsAttributes)),
            productParts: Data$dArray.fromFoldableImpl(Data$dFoldable.foldrArray, partsAttributes),
            parameters: nonDivisibleParametersResult,
            modifiers: modifierResult
          }));
        }));
      }));
    });
  }))));
};
const cartComboToOrderItems = catalogue => locale => availabilityScheduleValues => cartComboKey => internalParameters => {
  const comboId = cartComboKey.comboId;
  return bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(comboId)(catalogue.combos))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
    "ComboNotFound",
    comboId
  )))(v => bindCartToOrder.bind(checkGeneralAvailability(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ComboNotAvailable)(comboId)(v.availability))(() => bindCartToOrder.bind(checkAvailabilitySchedule(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ComboNotAvailable)(availabilityScheduleValues)(comboId)(v.availabilitySchedule))(() => functorCartToOrder.map(Data$dArray.catMaybes)(for2(v.elements._2)(v1 => {
    const v2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v1._1)(cartComboKey.elements);
    if (v2.tag === "Nothing") {
      if (v1._2.skippable) { return applicativeCartToOrder.pure(Data$dMaybe.Nothing); }
      return fatalError(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError("ComboElementNotSet", comboId, v1._1));
    }
    if (v2.tag === "Just") {
      const userCustomParameterValues = v2._1.customParameters;
      const modifierValues = v2._1.modifiers;
      return bindCartToOrder.bind(orFatal(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v2._1.comboChoiceId)(v1._2.choices._1))(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.$FatalError(
        "InvalidComboChoice",
        comboId,
        v1._1
      )))(productChoice => {
        const userParameterValues = Data$dMap$dInternal.unsafeUnionWith(
          Data$dOrd.ordString.compare,
          Data$dFunction.const,
          userCustomParameterValues,
          productChoice.customParameterValues
        );
        return functorCartToOrder.map(Data$dMaybe.Just)(cartProductToOrderItems(catalogue)(locale)(availabilityScheduleValues)({
          customParameters: userParameterValues,
          modifiers: modifierValues,
          parts: [{productId: productChoice.product, customParameters: userParameterValues, modifiers: modifierValues}]
        })(internalParameters)((() => {
          if (productChoice.priceOverride.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
          if (productChoice.priceOverride.tag === "Just") {
            return Data$dMap$dInternal.$$$Map("Node", 1, 1, productChoice.product, productChoice.priceOverride._1, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf);
          }
          $runtime.fail();
        })()));
      });
    }
    $runtime.fail();
  })))));
};
export {
  CartToOrder,
  all,
  append,
  applicativeCartToOrder,
  applyCartToOrder,
  bindCartToOrder,
  calculateAvailabilityScheduleValues,
  cartComboToOrderItems,
  cartModifierToItemAttributes,
  cartProductToOrderItems,
  checkAvailabilitySchedule,
  checkGeneralAvailability,
  customParameterToParameterAttributes,
  defaultModifierSettings,
  difference,
  evaluateParametricM,
  fatalError,
  fold1,
  fold2,
  fold3,
  for1,
  for2,
  for_,
  for_1,
  for_2,
  fromArray,
  fromCustomParameterValues,
  fromFoldable2,
  fromInternalParameterValues,
  fromOccurArray,
  functorCartToOrder,
  hasSingleValue,
  identity,
  intercalate,
  internalParameterToParameterAttributes,
  length,
  mapKeys,
  max,
  monadCartToOrder,
  newtypeCartToOrder,
  orFatal,
  restoreOrderingOccur,
  runCartToOrder,
  showArray,
  showCartToOrder,
  showEither,
  softError,
  sum,
  sum1,
  tell,
  toAvailabilityScheduleInternalParameterValues,
  toSimpleParametricEvaluationError,
  toUnfoldable,
  traverse,
  traverse1,
  traverse_,
  withName
};
